import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PortalLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/client-portal/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(form),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.detail || "Couldn't sign in — try again");
      navigate("/portal");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#142129] flex items-center justify-center p-4" data-testid="portal-login">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-t-2xl px-8 py-6 flex justify-center">
          <img src="/site-assets/logo.png" alt="Wales Event Medical Services" className="h-16 w-auto" />
        </div>
        <div className="bg-white/95 rounded-b-2xl px-8 pb-8 pt-2 border-t border-slate-100">
          <h1 className="text-2xl font-bold text-[#1c3d49]">Client Portal</h1>
          <p className="text-sm text-slate-500 mt-1">Invoices, quotes, event reports and documents for your events.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs font-semibold text-slate-600 block mb-1.5">Email</label>
              <input type="email" required value={form.email} data-testid="portal-login-email"
                onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                placeholder="you@yourcompany.co.uk"
                className="w-full h-12 rounded-lg border border-slate-300 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#1e7d8c]" />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-600 block mb-1.5">Password</label>
              <input type="password" required value={form.password} data-testid="portal-login-password"
                onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
                placeholder="Your password"
                className="w-full h-12 rounded-lg border border-slate-300 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#1e7d8c]" />
            </div>
            {error && <p className="text-sm text-[#D5281B] font-medium" data-testid="portal-login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="portal-login-submit"
              className="w-full h-12 rounded-lg bg-[#1e7d8c] hover:bg-[#176472] disabled:opacity-50 transition-colors text-white text-sm font-semibold inline-flex items-center justify-center gap-2">
              <LogIn className="h-4 w-4" /> {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
          <p className="text-xs text-slate-400 mt-5 flex items-start gap-1.5">
            <Lock className="h-3.5 w-3.5 shrink-0 mt-0.5" />
            Don't have a login? Ask Wales Event Medical Services and they'll set one up for you.
          </p>
        </div>
      </div>
    </div>
  );
}
